export default function insertStyle ({ src, callback, pass }) {
    if (pass) {
        if (callback) {
            setTimeout(callback, 0);
        }
    } else {
        let link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('href', src);

        document.head.prepend(link);
        link.onload = callback;
    }
}
